import { boolean, InferType, number, object, string } from "yup";
import { LangType } from "./LangType";
import { TTagType } from "./Message";

export const TemplateShcema = object({
    id: number().required(),
    title: string().required(),
    tag: string<TTagType>().required(),
    lang: string<LangType>().required(),
    text: string().required(),
    active: boolean(),
});

export const TemplateDTOSchema = TemplateShcema.pick(["title", "lang", "text", "tag"]);

export type Template = InferType<typeof TemplateShcema>;
export type UpsetTemplateDTO = InferType<typeof TemplateDTOSchema>;
